import type { SyncResponse } from "../types";
import { apiFetch } from "./client";
import {
  canonicalStockyPublicBigIntId,
  type StockyPublicBigIntId,
} from "./stocky_public_ids";

function normalizeSyncResponse(value: unknown): SyncResponse {
  if (value === null || typeof value !== "object" || Array.isArray(value)) {
    throw new TypeError("sync response is invalid");
  }
  const response = value as Omit<SyncResponse, "shop_id"> & {
    shop_id: unknown;
  };
  return {
    ...response,
    shop_id: canonicalStockyPublicBigIntId(response.shop_id),
  };
}

export async function triggerSync(
  shopId: StockyPublicBigIntId,
): Promise<SyncResponse> {
  const canonicalShopId = canonicalStockyPublicBigIntId(shopId);
  return normalizeSyncResponse(
    await apiFetch<unknown>(
      `/internal/sync/${encodeURIComponent(canonicalShopId)}`,
      { method: "POST" },
    ),
  );
}
